
const state = {
  configVersion: null,
  controllerConfig: {
    data: {},
    error: false,
    loading: true
  },
  versionOptions: [],
  features: [],
  statusBarOpen: false,
};
const getters = {
  getConfigVersion: state => state.configVersion,
  getSiteCommandControllerData: state => state.controllerConfig,
  getSiteCommandConfigVersionOptions: state => state.versionOptions,
  getSiteCommandControllerFeatures: state => state.features,
  isControllerStatusBarOpen: state => state.statusBarOpen,
};
const actions = {
};
const mutations = {
  setConfigVersion(state, version) {
    state.configVersion = version
  },
  setSiteCommandControllerData(state, [data, error]) {
    state.controllerConfig.data = data
    state.controllerConfig.error = error
    state.controllerConfig.loading = false
  },
  setSiteCommandConfigVersionOptions(state, options) {
    state.versionOptions = options
  },
  setSiteCommandControllerFeatures(state, array) {
    state.features = array
  },
  setControllerStatusBarOpen(state, open) {
    state.statusBarOpen = open
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};